import Vue from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import select from 'dom-select'
import { contains, refreshYotpoWidgets, set, unset } from 'lib/util'
import state from 'lib/appState'
import on from 'dom-event'

export default el => {
  const children = select.all('.pdp-quotes__section', el)
  return new Vue({
    el,
    data: {
      activeIndex: 0,
      state,
      swiperOption: {
        centeredSlides: children.length < 3,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.pdp-quotes__section-arrow.next',
          prevEl: '.pdp-quotes__section-arrow.prev'
        },
        pagination: {
          el: '.pdp-quotes__section-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      }
    },
    components: {
      swiper,
      swiperSlide
    },
    watch: {
      'state.activeProduct': {
        handler () {
          this.$nextTick(() => {
            if (this.$refs.swiper && this.$refs.swiper.swiper) {
              this.$refs.swiper.swiper.slideTo(this.activeIndex)
            }
            this.toggleSlidesVisibility()
          })
          setTimeout(() => {
            const allDots = select.all('.swiper-pagination-bullet', this.$el)
            if (allDots) {
              allDots.forEach((dot) => {
                dot.removeAttribute('aria-current')
                let div = document.createElement('div')
                let outer = dot.outerHTML

                // Replace opening tag
                let regex = new RegExp('<' + 'span', 'i')
                let newTag = outer.replace(regex, '<' + 'li')

                // Replace closing tag
                regex = new RegExp('</' + 'span', 'i')
                newTag = newTag.replace(regex, '</' + 'li')

                div.innerHTML = newTag.trim()

                dot.replaceWith(div.firstChild)
              })
            }
            const allDotsNew = select.all('.swiper-pagination-bullet', this.$el)

            this.$refs.swiper.swiper.on('slideChange', () => {
              allDotsNew.forEach((dot, index) => {
                if (this.$refs.swiper.swiper.activeIndex === index) {
                  dot.setAttribute('aria-current', true)
                  set(dot, 'swiper-pagination-bullet-active')
                } else {
                  dot.removeAttribute('aria-current')
                  unset(dot, 'swiper-pagination-bullet-active')
                }
              })
            })
          }, 500)
        },
        deep: true
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.toggleSlidesVisibility()
      })
    },
    computed: {
      updateActiveIndex () {
        this.activeIndex = this.$refs.swiper.swiper.activeIndex
      },
      getPdpQuotes () {
        if (Object.keys(this.state.activeProduct).length) {
          return this.state.activeProduct.pdpQuotes
        }
        return []
      },
      quoteTitle () {
        if (Object.keys(this.getPdpQuotes).length) {
          return this.getPdpQuotes.quoteTitle
        }
        return []
      },
      quoteContents () {
        if (Object.keys(this.getPdpQuotes).length && Object.keys(this.getPdpQuotes.quoteContents).length) {
          return this.getPdpQuotes.quoteContents
        }
        return []
      },
      quoteImages () {
        if (Object.keys(this.getPdpQuotes).length && Object.keys(this.getPdpQuotes.quoteImages).length) {
          return this.getPdpQuotes.quoteImages
        }
        return []
      },
      ugcImages () {
        if (Object.keys(this.getPdpQuotes).length && Object.keys(this.getPdpQuotes.ugcImages).length) {
          return this.getPdpQuotes.ugcImages
        }
        return []
      },
      ugcTags () {
        if (Object.keys(this.getPdpQuotes).length && this.getPdpQuotes.ugcTags) {
          return this.getPdpQuotes.ugcTags
        }
        return []
      }
    },
    methods: {
      setSlideVisibility (slide) {
        const focusableEls = select.all(['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'], slide)
        slide.removeAttribute('aria-hidden')
        if (focusableEls.length) {
          focusableEls.forEach(el => {
            el.removeAttribute('tabindex')
          })
        }
      },
      unsetSlideVisibility (slide) {
        const focusableEls = select.all(['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'], slide)
        slide.setAttribute('aria-hidden', true)
        if (focusableEls.length) {
          focusableEls.forEach(el => {
            el.setAttribute('tabindex', '-1')
          })
        }
      },
      toggleSlidesVisibility () {
        const slides = Array.from(this.$refs.swiper.swiper.slides)
        const swiper = this.$children && this.$children[0] ? this.$children[0].swiper : null
        if (!swiper) {
          return
        }

        slides.forEach((slide, index) => {
          if (contains(slide, 'swiper-slide-visible')) {
            if (swiper.slidesGrid[index] < Math.abs(swiper.translate)) {
              this.unsetSlideVisibility(slide)
            } else {
              this.setSlideVisibility(slide)
            }
          } else {
            this.unsetSlideVisibility(slide)
          }
        })
      }
    }
  })
}
